import React, { useEffect } from 'react';
import './materials.css';
import { useTranslation } from 'react-i18next';
import { MdClose } from 'react-icons/md';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import { useLocalized } from '../../i18n/useLocalized';

/**
 * Full-screen image viewer with caption (title + description),
 * prev/next navigation, keyboard support and body scroll lock.
 */
const Lightbox = ({ items, index, onClose, onNavigate }) => {
    const { t } = useTranslation();
    const loc = useLocalized();
    const item = items[index];

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === 'Escape') onClose();
            if (e.key === 'ArrowLeft') onNavigate(-1);
            if (e.key === 'ArrowRight') onNavigate(1);
        };
        window.addEventListener('keydown', handleKey);

        // Lock page scroll while the viewer is open
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            window.removeEventListener('keydown', handleKey);
            document.body.style.overflow = previousOverflow;
        };
    }, [onClose, onNavigate]);

    if (!item) return null;

    return (
        <div className="lightbox" onClick={onClose}>
            <MdClose className="closeButton" onClick={onClose}/>

            {items.length > 1 && (
                <>
                    <button
                        className="lbArrow lbPrev"
                        aria-label={t('gallery.prevImage')}
                        onClick={(e) => { e.stopPropagation(); onNavigate(-1); }}
                    >
                        <BsArrowLeft/>
                    </button>
                    <button
                        className="lbArrow lbNext"
                        aria-label={t('gallery.nextImage')}
                        onClick={(e) => { e.stopPropagation(); onNavigate(1); }}
                    >
                        <BsArrowRight/>
                    </button>
                </>
            )}

            <figure className="lbFigure" key={item.id ?? index} onClick={(e) => e.stopPropagation()}>
                <img src={item.image} alt={loc(item, 'title')}/>
                <figcaption>
                    <h3>{loc(item, 'title')}</h3>
                    {loc(item, 'description') && <p>{loc(item, 'description')}</p>}
                    {items.length > 1 && (
                        <span className="lbCount">{index + 1} / {items.length}</span>
                    )}
                </figcaption>
            </figure>
        </div>
    );
};

export default Lightbox;
